import { type SearchItem } from './search'

export const applyBeneficiaryUrls = (items: SearchItem[], baseUrl: string | undefined): SearchItem[] => {
  if (typeof baseUrl !== 'string' || baseUrl.length === 0) return items

  return items.map(item => {
    if (item.url || !item.id) return item

    const url = new URL(baseUrl, window.location.origin)

    url.searchParams.set('beneficiary_id', String(item.id))

    return { ...item, type: 'link' as const, url: url.pathname + url.search + url.hash }
  })
}
